<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Acquiring Transaction Types"
              bc1="App"
              bc2="Acquiring Transaction Types"
              bc3="List"
              path="acquirings"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0)">Schema</a></li>
                      <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div class="col-6">
                <div class="d-flex align-items-center justify-content-end">
                  <select class="form-control mr-1" v-model="selectedType">
                    <option :key="index" :value="option.id" v-for="(option, index) in exteranalApitransactionTypes">
                      {{option.name}}
                    </option>
                  </select>
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="addRecord"
                  >
                    <span class="text-nowrap">Add Transaction Type</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div class="card">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Actions</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in transaction_types" :key="index">

                      <td>{{index+1}}</td>
                      <td>{{item.name}}</td>
                      <td v-if="item.pivot.status == 1"><span class="badge badge-success badge-sm badge-glow">Active</span></td>
                      <td v-else><span class="badge badge-danger badge-sm badge-glow">Inactive</span></td>
                      <td><button type="button" @click="openModal(item,index)" class="btn btn-primary btn-sm">Update</button></td>



                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transactionTypeUpdateModal :typeData="modalData" :show="showModal" @hide="showModal = false"/>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

import { mapState } from 'vuex'
import transactionTypeUpdateModal from "@/pages/dashboard/acquirings/transactionTypeUpdateModal";
export default {
  computed: {
    ...mapState(['acquiringMainTransactionTypes'])
  },
  components:{
    transactionTypeUpdateModal
  },
  mounted() {
    this.getTransactionTypes()
    var acquiringTransactionTypeData = this.$store.getters.getByKey(
        "acquiringMainTransactionTypes"
    );

    this.currentBreadCrumb.push(acquiringTransactionTypeData.row.name+'/'+acquiringTransactionTypeData.row.code)

    this.transaction_types = acquiringTransactionTypeData.row.transaction_types
    this.aquiringId = acquiringTransactionTypeData.row.id
  },
  data() {
    return {
      transaction_types:[],
      showModal:false,
      modalData:[],
      exteranalApitransactionTypes:[],
      selectedType:null,
      aquiringId:'',
      currentBreadCrumb:[]

    };
  },
  methods: {
    getTransactionTypes() {
      this.makeRequest(
          "post",
          "v1/transaction-types",
          {},
          {},
          false,
          true,
          [205]
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.exteranalApitransactionTypes = callResponse.response.data.data
            if(this.exteranalApitransactionTypes)
            this.selectedType = this.exteranalApitransactionTypes[0].id
          }
        }
      });
    },
    addRecord(){
      this.makeRequest(
          "post",
          "v1/manage-aquiring-transaction-types",
          {
            aquiringId : this.aquiringId,
            type : 'add',
            transactionTypeId : this.selectedType,
          },
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.transaction_types = callResponse.response.data.data
            var acquiringTransctionTypeStoreData = this.$store.getters.getByKey(
                "acquiringMainTransactionTypes"
            );
            acquiringTransctionTypeStoreData.row.transaction_types = this.transaction_types
            this.$store.dispatch("set", acquiringTransctionTypeStoreData);
          }
        }
      });
    },
    openModal(item,index){
      let data = {
        item: item,
        index: index,
        transactionTypes:this.exteranalApitransactionTypes,
        aquiringId:this.aquiringId
      }
      this.modalData = data
      this.showModal = true

    }
  },
  watch:{
    acquiringMainTransactionTypes(val){
      let data = JSON.parse(val)
      this.transaction_types = data.row.transaction_types


    }
  }
};
</script>

